import { AbstractWinDisplayProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractWinDisplayProperties";
/**
 * WinDisplayPortraitProperties.ts
 */
export class WinDisplayPortraitProperties extends AbstractWinDisplayProperties {
}
//# sourceMappingURL=WinDisplayPortraitProperties.js.map